export default {
  tabUrl: 'data-tab-url',
  container: 'data-quicktab',
  contextmenu: 'data-qt-contextmenu',
  dropdown: 'data-qt-dropdown',
  //记录iframe的状态 true:表示已经加载完毕
  iframeLoaded: 'loaded',
  addTabTarget: 'data-qt-target',
  addTabParentTarget: 'data-qt-parent-target',
  addTabUrl: 'data-qt-tab-url',
  addTabTitle: 'data-qt-tab-title',
  addTabClosable: 'data-qt-tab-closable',
  //iframe的超时句柄
  iframeTimeoutTimer: 'timer',
  //每个tab的选项数据存储在dom上的key
  tabOptionDataKey: 'qtab',
  //选项的时间戳的key
  tabOptionTimeKey: 'timestamp',
}
